import IconWithLabel from "./IconWithLabel";

export default function IconsWithLabels({items}) {
    return (
        <section className="grid grid-cols-2 md:grid-cols-3 gap-x-10 gap-y-12 md:gap-x-10 md:gap-y-20 mx-auto">
            {items.map((item, key) => <IconWithLabel {...item} key={`IconWithLabel: ${key}`}/>)}
        </section>
    )
}